module.exports = __webpack_public_path__ + "static/img/组 36 拷贝 4@3x.8a012ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/组 36 拷贝 4@3x.png
// module id = N9HN
// module chunks = 18